<template>
    <div>
        <div class="d-flex h-100 w-100">
            <div class="col-md-3">
                <searchTotalCost @search="formSearch = $event"></searchTotalCost>
            </div>
            <div class="col-md-9">
                <chartTotalCost :formSearch="formSearch"></chartTotalCost>
            </div>
        </div>
    </div>
</template>

<script>
import TotalCost from './totalCost.js'
export default TotalCost

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/totalCost/totalCost.vue